var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVimeoSocial({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-vimeo-social",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_white",
    "data-name": "Ellipse white",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_grey",
    "data-name": "Ellipse grey",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(5 5)",
    fill: "#e3e3e3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm7.07,6.71q-.094,2.067-2.887,5.661Q11.3,16.124,9.3,16.124q-1.237,0-2.093-2.286-.571-2.1-1.143-4.19Q5.429,7.362,4.7,7.361a4.39,4.39,0,0,0-1.111.667L2.923,7.17q1.047-.92,2.065-1.843a4.688,4.688,0,0,1,2.1-1.271Q8.738,3.9,9.12,6.316q.412,2.61.572,3.245.476,2.165,1.048,2.165.445,0,1.335-1.4a5.541,5.541,0,0,0,.953-2.138q.127-1.213-.953-1.213a2.636,2.636,0,0,0-1.048.232q1.043-3.418,3.986-3.324Q17.2,3.943,17.07,6.71Z",
    transform: "translate(5 5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeoSocial);
export default __webpack_public_path__ + "static/media/vimeo-social.e9334f66d0f1ecf825af3f69844dade7.svg";
export { ForwardRef as ReactComponent };